import { Router } from 'framework7/types';
import { SubscriptionCompletePage } from '@/components/pages/Subscription/SubscriptionCompletePage';
import { SubscriptionConfirmPage } from '@/components/pages/Subscription/SubscriptionConfirmPage';
import { SubscriptionDetailPage } from '@/components/pages/Subscription/SubscriptionDetailPage';
import { SubscriptionMyPage } from '@/components/pages/Subscription/SubscriptionMyPage';
import { SubscriptionPaymentPage } from '@/components/pages/Subscription/SubscriptionPaymentPage';
import { paths } from '@/config/paths';

export const subscriptionRoutes: Router.RouteParameters[] = [
  {
    path: paths.subscriptionDetail,
    component: SubscriptionDetailPage,
    name: 'マイくるプラス',
  },
  {
    path: paths.subscriptionPayment,
    component: SubscriptionPaymentPage,
    name: '決済方法選択',
  },
  {
    path: paths.subscriptionConfirm,
    component: SubscriptionConfirmPage,
    name: '申込確認',
  },
  {
    path: paths.subscriptionComplete,
    component: SubscriptionCompletePage,
    name: '申込完了',
  },
  {
    path: paths.subscriptionMyPage,
    component: SubscriptionMyPage,
    name: 'サブスクリプション契約',
  },
];
